import { render, staticRenderFns } from "./fundusTest.vue?vue&type=template&id=4e1ef572&scoped=true&"
import script from "./fundusTest.vue?vue&type=script&lang=js&"
export * from "./fundusTest.vue?vue&type=script&lang=js&"
import style0 from "./fundusTest.vue?vue&type=style&index=0&id=4e1ef572&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1ef572",
  null
  
)

export default component.exports